<template>
    <div class="ShortCourse">
        <b-modal size="lg" id="bv-modal-address" hide-footer>
            <template v-slot:modal-title>Dirección de Residencia</template>
            <div class="detalleAddress">  
                <ValidationObserver ref="obsFieldsAddress">
                    <FormAddress :FieldsForm="formAddress" :ModelForm="this.formAddModel" :method="executeProcess" />
                </ValidationObserver>
                <div class="row botonData">
                <div class="text-left  col-md-10">              
                </div>
                <div class="text-right  col-md-2">
                    <br>
                    <button type="submit" v-on:click="executeAddress" class="botonRef">Aplicar</button>
                </div>
                </div>
            </div>
        </b-modal> 
        <div class="infoTitle">{{this.$route.params.curso.replace(/-/g, ' ')}}</div>
        <div class="titleRef notranslate">
            Bienvenido. A partir de éste momento usted inicia una experiencia de aprendizaje con la Iberoamericana.
            <br>
            A continuación encontrará el formulario que le solicitamos diligenciar en su totalidad. Esperamos disfute de la experiencia que hemos preparado para usted. 
            </div>
        <div v-if="!sendDataForm" class="alert alert-success" role="alert">
            Se ha generado la inscripción al curso exitosamente.
        </div>     
        <div v-if="alertdanger" class="alert alert-danger" role="alert">
            Se ha generado un problema con la información ingresada, por favor intente nuevamente el registro.
        </div>        
        <div v-if="sendDataForm">
            <ValidationObserver ref="obsFields">
                <FormShortCourses :FieldsForm="formShortCourse" :ModelForm="formCourseModel" :method="executeProcess" />                                     
            </ValidationObserver>       
        </div>
        <div class="row botonData" v-if="sendDataForm">
            <div class="text-left  col-md-10">              
            </div>
            <div class="text-right  col-md-2">
            <button type="submit" v-on:click="executeForm" class="botonRef">Inscripción</button>
            </div>
        </div> 
    </div>
</template>

<script>
import FormShortCourses from '@/components/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import FormAddress from '@/components/Forms.vue'

export default {
  name: 'ShortCourse',
  components: {
    FormShortCourses,
    FormAddress,
  },  
  methods: { 
    executeAddress: function (){
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsAddress.validate().then(results => {         
          if (!results) {
            IberoHelpers.scrollToTop(0,500);
            resolve(false)
          }else{
            this.formCourseModel.IdAddress = IberoHelpers.dataObjFind(this.$store.state.listAddress,this.formAddModel.IdAddressList) + ' ' + this.formAddModel.IdAddressStreet + ' # ' + this.formAddModel.IdAddressNum + ' - ' + this.formAddModel.IdAddressRef;
            if(this.formAddModel.IdAddressExtra != ''){
              this.formCourseModel.IdAddress += ' | ' + this.formAddModel.IdAddressExtra;
            }
            this.$root.$emit('bv::hide::modal', 'bv-modal-address', '#btnHide')  
            resolve(true)
          }
        });  
      });              
    },      
    executeForm(){
        this.sendDataForm = true
        this.alertdanger = false
        return new Promise((resolve, reject) => {
            this.$refs.obsFields.validate().then(results => {    
                if (!results) {
                    IberoHelpers.scrollToTop(0,0)
                    resolve(false)
                }else{
                    let loader = this.$loading.show()                    
                    var totalinf = IberoHelpers.sendFormInsShortCourse(this.$store,this.formCourseModel);  
                    totalinf.then(
                        Response => { 
                            IberoHelpers.scrollToTop(0,0);
                            if(Response === false || Response.data.status != 200 ){                    
                                this.alertdanger = true
                                this.sendDataForm = true
                                resolve(false)
                            }else{                
                                this.alertdanger = false                
                                this.sendDataForm = false
                                resolve(true)                                
                            }                      
                            loader.hide();
                        }
                    )                    
                }            
            });
        });
    },
    executeProcess: function (event) {        
        switch (event.target.id) {
            case "IdState":
                this.formCourseModel.IdCity = '';
                if(event.target.value === ''){            
                    this.formShortCourse[4].values = '';
                }else{
                    IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityList,event.target.value);
                    this.formShortCourse[4].values = this.$store.state.CityList;
                }
            break;
            case "IdStateRes":
                this.formCourseModel.IdCityRes = '';
                if(event.target.value === ''){            
                    this.formShortCourse[15].values = '';
                }else{
                    IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityListRes,event.target.value);
                    this.formShortCourse[15].values = this.$store.state.CityListRes;
                }
            break;
            case "IdStateBirth":
                this.formCourseModel.IdCityBirth = '';
                if(event.target.value === ''){            
                    this.formShortCourse[18].values = '';
                }else{
                    IberoHelpers.getCitiesListByState(this.$store.state.ApiIbero.WSParametric,this.$store.state.CityListBirth,event.target.value);
                    this.formShortCourse[18].values = this.$store.state.CityListBirth;
                }
            break;             
            case "IdAddress":
                this.$root.$emit('bv::show::modal', 'bv-modal-address', '#btnShow')          
            break;
            case "IdNacionality":
            if (event.target.value != 169) {
                document.getElementById("div_IdStateBirth").classList.add('noShow');
                document.getElementById("div_IdCityBirth").classList.add('noShow');
                this.formCourseModel.IdStateBirth = '11'
                this.formCourseModel.IdCityBirth = '11001'
            } else {
                document.getElementById("div_IdStateBirth").classList.remove('noShow');
                document.getElementById("div_IdCityBirth").classList.remove('noShow');
                this.formCourseModel.IdStateBirth = ''
                this.formCourseModel.IdCityBirth = ''            
            }
            break;
            case "cbox_IdTermiCondi":                   
                event.target.disabled = true;   
            break;              
            return true;            
        }
    }      
  },
  data() {
      return {
          alertdanger: false,
          sendDataForm: true,
          formAddModel: {
            IdAddressList: '',
            IdAddressStreet: '',
            IdAddressNumTxt: '',
            IdAddressNum: '',
            IdAddressRefTxt: '',
            IdAddressRef: '',
            IdAddressExtra: '',
          },  
          formAddress:[
            {
                id: 'IdAddressList',
                model: 'IdAddressList',
                type: 'Select',  
                values: this.$store.state.listAddress,
                placeholder: 'Dirección',
                validate: {              
                required: true              
                },
                class: 'col-md-3'               
            },
            {
                id: 'IdAddressStreet',
                model: 'IdAddressStreet',
                type: 'input',              
                values: '',
                validate: {              
                required: true, 
                alpha_num: true,
                max: 4,                            
                },
                class: 'col-md-2'               
            },
            {            
                id: 'IdAddressNumTxt',
                model: 'IdAddressNumTxt',
                type: 'html',  
                values: '#',                     
                class: 'col-md-1'                
            },      
            {
                id: 'IdAddressNum',
                model: 'IdAddressNum',
                type: 'input',  
                values: '',
                placeholder: '#',
                validate: {              
                required: true, 
                alpha_num: true,
                max: 4,               
                },
                class: 'col-md-2'               
            },
            {            
                id: 'IdAddressRefTxt',
                model: 'IdAddressRefTxt',
                type: 'html',  
                values: '-',                     
                class: 'col-md-1'                
            },   
            {
                id: 'IdAddressRef',
                model: 'IdAddressRef',
                type: 'input',  
                placeholder: '#',
                values: '',
                validate: {              
                required: true, 
                alpha_num: true,
                max: 4,                
                },
                class: 'col-md-2'               
            },        
            {
                id: 'IdAddressExtra',
                model: 'IdAddressExtra',
                type: 'input',  
                placeholder: 'Informacion adicional',
                values: '',
                validate: {              
                max: 35,                
                },
                class: 'col-md-11'               
            },                       
          ],                  
          formCourseModel: {
            IdOperator: 1,
            NameOperator: this.$route.params.operador.replace(/-/g, ' '),
            IdCourse: 1,
            NameCourse: this.$route.params.curso.replace(/-/g, ' '),
            IdDocType: '',            
            IdDocument: '',
            IdDateExpDoc: '',            
            IdState: '',
            IdCity: '',
            IdNombreP: '', 
            IdNombreS: '', 
            IdApellidosP: '', 
            IdApellidosS: '', 
            IdCelPhone: '', 
            IdHomePhone: '', 
            IdMail: '',
            IdAddress: '',
            IdNeighbor: '',
            IdStateRes: '',
            IdCityRes: '',
            IdNacionality: '169',
            IdStateBirth: '',
            IdCityBirth: '',
            IdDateBirth: '',
            IdGender: '',
            IdEtnia: '',
            IdDiscapa: '',
            IdCivilState: '',
            IdContactName: '',
            IdContactPhone: '',
            IdContactCity: '',
            IdContactAdres: '', 
            IdTermiCondi: '',            
          }, 
          formShortCourse: [          
            {            
                id: 'IdDocType',
                model: 'IdDocType',
                name: 'Tipo de Documento',
                type: 'Select',  
                placeholder: "Tipo de Documento",
                values: this.$store.state.DocTypesList,
                validate: {              
                    required: true              
                },
                class: 'col-md-6',
            },
            {            
                id: 'IdDocument',
                model: 'IdDocument',
                name: 'Documento de Identidad',
                type: 'input',  
                placeholder: 'Documento de Identidad',
                values: '',
                validate: {              
                    required: true, 
                    min: 7,              
                    max: 10            
                },
                class: 'col-md-6'               
            },
            {            
                id: 'IdDateExpDoc',
                model: 'IdDateExpDoc',
                name: 'Fecha de Expedición de Documento',
                type: 'datepicker',  
                placeholder: 'dd/mm/aaaa',
                values: new Date(),
                dateTimePickerOptions: {
                    format: this.$store.state.dateFormat,
                    disabledDates:{
                    to: new Date(1900, 0, 1), 
                    from: new Date(), 
                    }           
                },
                validate: {              
                    required: true              
                },
                class: 'col-md-6'               
            },
            {
                id: 'IdState',
                model: 'IdState',
                name: 'Departamento de Expedición Documento',
                type: 'Select',  
                placeholder: 'Departamento de Expedición Documento',
                class: 'col-md-6',            
                values: this.$store.state.StateList,
                validate: {              
                    required: true              
                },
            },
            {
                id: 'IdCity',
                model: 'IdCity',
                name: 'Ciudad de Expedición Documento',
                type: 'Select',  
                placeholder: 'Ciudad de Expedición Documento',
                validate: {              
                    required: true              
                },
                class: 'col-md-6',            
                values: '',
            },
            {            
                id: 'IdMail',
                model: 'IdMail',
                name: 'Correo Electrónico',
                type: 'input',  
                placeholder: 'Correo Electrónico',
                values: '',
                validate: {
                required: true, 
                email: true 
                },
                class: 'col-md-6'               
            }, 
            {            
                id: 'IdNombreP',
                model: 'IdNombreP',
                name: 'Primer Nombre',
                type: 'input',  
                placeholder: 'Primer Nombre',
                values: '',
                validate: {              
                    required: true              
                },
                class: 'col-md-6'               
            },
            {            
                id: 'IdNombreS',
                model: 'IdNombreS',
                name: 'Segundo Nombre',
                type: 'input',  
                placeholder: 'Segundo Nombre',
                values: '',
                validate: {              
                    required: false              
                },
                class: 'col-md-6'               
            },            
            {            
                id: 'IdApellidosP',
                model: 'IdApellidosP',
                name: 'Primer Apellido',
                type: 'input',  
                placeholder: 'Primer Apellido',
                values: '',
                validate: {              
                    required: true              
                },
                class: 'col-md-6'               
            },
            {            
                id: 'IdApellidosS',
                model: 'IdApellidosS',
                name: 'Segun Apellido',
                type: 'input',  
                placeholder: 'Segundo Apellido',
                values: '',
                validate: {              
                    required: false              
                },
                class: 'col-md-6'               
            },           
            {            
                id: 'IdCelPhone',
                model: 'IdCelPhone',
                name: 'Teléfono Celular',
                type: 'input',  
                placeholder: 'Teléfono Celular',
                values: '',
                validate: {
                    required: true, 
                    numeric: true,
                    max: 10,
                    min: 10 
                },  
                class: 'col-md-6'               
            },      
            {            
                id: 'IdHomePhone',
                model: 'IdHomePhone',
                name: 'Teléfono Fijo',
                type: 'input',  
                placeholder: 'Teléfono Fijo',
                values: '',
                validate: {
                    required: false, 
                    numeric: true,
                    max: 7,
                    min: 6 
                },         
                class: 'col-md-6'               
            },              
            {
                id: 'IdAddress',
                model: 'IdAddress',
                name: 'Dirección',
                type: 'inputkey',  
                placeholder: 'Dirección',
                values: '',
                validate: {              
                    required: true              
                },
                class: 'col-md-6'               
            },
            {
                id: 'IdNeighbor',
                model: 'IdNeighbor',
                name: 'Barrio',
                type: 'input',  
                placeholder: 'Barrio',
                values: '',
                validate: {              
                    required: true              
                },
                class: 'col-md-6'               
            }, 
            {
                id: 'IdStateRes',
                model: 'IdStateRes',
                name: 'Departamento de Residencia',
                type: 'Select',  
                placeholder: 'Departamento de Residencia',
                class: 'col-md-6',            
                values: this.$store.state.StateList,
                validate: {              
                    required: true              
                },
            },
            {
                id: 'IdCityRes',
                model: 'IdCityRes',
                name: 'Ciudad de Residencia',
                type: 'Select',  
                placeholder: 'Ciudad de Residencia',
                validate: {              
                    required: true              
                },
                class: 'col-md-6',            
                values: '',
            },   
            {
                id: 'IdNacionality',
                model: 'IdNacionality',
                name: 'Nacionalidad',
                type: 'Select',  
                placeholder: 'Nacionalidad',
                class: 'col-md-6',            
                values: this.$store.state.CountriesList,
                validate: {              
                    required: true              
                },
            },           
            {
                id: 'IdStateBirth',
                model: 'IdStateBirth',
                name: 'Departamento de Nacimiento',
                type: 'Select',  
                placeholder: 'Departamento de Nacimiento',
                class: 'col-md-6',            
                values: this.$store.state.StateList,
                validate: {              
                    required: true              
                },
            },
            {
                id: 'IdCityBirth',
                model: 'IdCityBirth',
                name: 'Ciudad de Nacimiento',
                type: 'Select',  
                placeholder: 'Ciudad de Nacimiento',
                validate: {              
                    required: true              
                },
                class: 'col-md-6',            
                values: '',
            },                             
            {            
                id: 'IdDateBirth',
                model: 'IdDateBirth',
                name: 'Fecha de Nacimiento',
                type: 'datepicker',  
                placeholder: 'dd/mm/aaaa',
                values: new Date(),
                dateTimePickerOptions: {
                    format: this.$store.state.dateFormat,
                    disabledDates:{
                        to: new Date(1900, 0, 1), 
                        from: new Date(), 
                    }           
                },
                validate: {              
                    required: true              
                },
                class: 'col-md-6'               
            },    
            {
                id: 'IdGender',
                model: 'IdGender',
                name: 'Genero',
                type: 'Select',  
                placeholder: 'Genero',
                class: 'col-md-6',            
                values: this.$store.state.GenderList,
                validate: {              
                    required: true              
                },
            },              
            {
                id: 'IdEtnia',
                model: 'IdEtnia',
                name: 'Grupo Étnico',
                type: 'Select',  
                placeholder: 'Grupo Étnico',
                class: 'col-md-6',            
                values: this.$store.state.EthnicityList,
                validate: {              
                    required: true              
                },
            }, 
            {
                id: 'IdDiscapa',
                model: 'IdDiscapa',
                name: 'Discapacidad',
                type: 'Select',  
                placeholder: 'Discapacidad',
                class: 'col-md-6',            
                values: this.$store.state.DesabilityList,
                validate: {              
                    required: true              
                },
            }, 
            {
                id: 'IdCivilState',
                model: 'IdCivilState',
                name: 'Estado Civil',
                type: 'Select',  
                placeholder: 'Estado Civil',
                class: 'col-md-6',            
                values: this.$store.state.MaritalStatusList,
                validate: {              
                    required: true              
                },
            },                
            {       
                id: 'IdContactName',
                model: 'IdContactName',
                name: 'Nombre del Acudiente',
                type: 'input',  
                placeholder: 'Nombre del Acudiente',
                values: '',
                validate: {              
                    required: false              
                },
                class: 'col-md-6'               
            },           
            {            
                id: 'IdContactPhone',
                model: 'IdContactPhone',
                name: 'Teléfono del Acudiente',
                type: 'input',  
                placeholder: 'Teléfono del Acudiente',
                values: '',
                validate: {
                    required: false, 
                    numeric: true,
                    max: 10,
                    min: 6
                },  
                class: 'col-md-6'               
            },
            {            
                id: 'IdContactCity',
                model: 'IdContactCity',
                name: 'Ciudad del Acudiente',
                type: 'input',  
                placeholder: 'Ciudad del Acudiente',
                values: '',
                validate: {
                    required: false
                },  
                class: 'col-md-6'               
            },
            {            
                id: 'IdContactAdres',
                model: 'IdContactAdres',
                name: 'Dirección del Acudiente',
                type: 'input',  
                placeholder: 'Dirección del Acudiente',
                values: '',
                validate: {
                    required: false
                },  
                class: 'col-md-6'        
            }, 
            {            
                id: 'IdTermiCondi',
                name: 'Términos y Condiciones',
                model: 'IdTermiCondi',
                type: 'accepted',  
                disabled: false,
                placeholder: 'Acepto los <a class="linkTerm" href="' + this.$store.state.linkTermiCondi + '" target="_blank">Términos y Condiciones</a> de uso.',
                values: '',
                validate: {              
                    required: true,
                },
                class: 'col-md-12 linkref'                
            },           
          ]
      }
  }
}
</script>

<style>
.ShortCourse{
    margin: 20px;
    padding: 30px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #ffffff;
    background:  #ffffff !important;       
}
#div_IdAddressNumTxt, #div_IdAddressRefTxt{
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -10px;
  text-align: center;
}
.detalleAddress .is-invalid-form{
  display: none;
}
#div_IdContactName{
  display: none;
}
#div_IdContactAdres{
    display: none;
}
#div_IdContactCity{
    display: none;
}
#div_IdContactPhone{
    display: none;
}

#div_IdTermiCondi .titleRef{
  color: #ffffff;
  margin-top: 10px;
}
.linkref a{
  color: #222 !important;
}

.active
{
    color: #222;
}

.linkref{
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: -5px;
}
body {
    background:  #fff;   
}
header {
    background:  #ffffff !important;   
}
.noShow{
  display: none;
}
.infoTitle{
  color: #222;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;  
  padding-bottom: 10px;
  margin-bottom: 10px;
}
</style>